import client from '../httpClient';

const responseGetMediumApi = (params) => {
  return client.get('/response-types/', { params });
};

export default responseGetMediumApi;
